import "./src/styles/global.css"

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.pathname === "/") {
    window.scrollTo(0, 0)
    return false
  }
  return true
}
